import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTrilogyContext } from '../../context';
import { hashClass } from '../../helpers';
import { has, is } from '../../services';
/**
 * Tabs Component
 * @param children {ReactNode} Children for tabs
 * @param onClick onClick event
 * @param activeIndex {number} default active tab index
 * @param disabled {boolean} Disabled tabs
 * @param clipped {boolean} Remove the separator bar
 * @param inverted {boolean} dark mode
 * @param shadowless {boolean} No shadow
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param centered {boolean} Centered tabs
 * @param rightAlign {boolean} Tabs right align
 * @param className {string} Additionnal CSS Classes
 * @param fullwidth {boolean} Fullwidth tabs
 * @param leftAlign {boolean} Tabs left align
 */
const Tabs = ({ children, className, onClick, activeIndex, disabled, rightAlign, fullwidth, align, centered, marginless, inverted, shadowless, textAlign, testId, ...others }) => {
    const [activateIndex, setActivateIndex] = useState(activeIndex || 0);
    const { styled } = useTrilogyContext();
    const [isIcons, setIsIcons] = React.useState(false);
    const classes = hashClass(styled, clsx('tabs', rightAlign && is('right'), fullwidth && is('fullwidth'), centered && is('centered'), marginless && is('marginless'), isIcons && is('icons'), className));
    const isActive = React.useCallback((index, childPropsActive) => {
        if (typeof childPropsActive !== 'undefined' && !activateIndex) {
            return childPropsActive;
        }
        if (index === activateIndex) {
            return true;
        }
    }, [activateIndex]);
    const toggleActive = React.useCallback((e, index) => {
        if (disabled) {
            return false;
        }
        setActivateIndex(index);
        if (onClick) {
            onClick(e);
        }
    }, [disabled]);
    useEffect(() => {
        setActivateIndex(activateIndex);
    }, [activeIndex]);
    return (React.createElement("div", { className: hashClass(styled, clsx('tab-context', inverted && is('inverted'), align && has(`text-${align}`), shadowless && is('shadowless'), textAlign && textAlign)), "data-testid": testId },
        React.createElement("div", { className: classes, role: 'tablist', ...others }, activateIndex
            ? React.Children.map(children, (child, index) => {
                if (React.isValidElement(child)) {
                    if (!isIcons && child.props.iconName)
                        setIsIcons(true);
                    const active = Boolean(isActive(index, child.props.active)) || false;
                    const key = index;
                    const props = {
                        active,
                        key,
                        onClick: (e) => {
                            toggleActive(e, index);
                            if (child) {
                                if (child.props.onClick) {
                                    child.props.onClick(e);
                                }
                            }
                        },
                    };
                    return React.cloneElement(child, props);
                }
            })
            : children)));
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map